import getOrganization from "../../services/getters/organization_getters/get_organization";
import loadOrganization from "../../actions/react_query/organizations/load_organization";
import useQueryWithState from "../use_query_with_state";

const useOrganization = (organizationId: string) => {
  return useQueryWithState(["useOrganization", organizationId], loadOrganization, getOrganization, { enabled: !!organizationId }, { organizationId }, organizationId);
};

export default useOrganization;
